const IconPause = ({ className }) => {
    return (
        <svg xmlns='http://www.w3.org/2000/svg' x='0px' y='0px' viewBox='0 0 409.6 409.6' className={className}>
            <path
                d='M204.8,0C91.648,0,0,91.648,0,204.8s91.648,204.8,204.8,204.8s204.8-91.648,204.8-204.8S317.952,0,204.8,0z M182.272,256
                    c0,12.8-10.24,22.528-22.528,22.528c-12.8,0-22.528-10.24-22.528-22.528V153.6c-0.512-12.288,9.728-22.528,22.016-22.528
                    c12.8,0,23.04,10.24,23.04,22.528V256z M272.896,256c0,12.8-10.24,22.528-22.528,22.528c-12.8,0-22.528-10.24-22.528-22.528V153.6
                    c-0.512-12.288,9.728-22.528,22.016-22.528c12.8,0,23.04,10.24,23.04,22.528V256z'
            ></path>
        </svg>
    );
};

export default IconPause;
